import { render, staticRenderFns } from "./UsuarioLista.vue?vue&type=template&id=2c34c136"
import script from "./UsuarioLista.vue?vue&type=script&lang=js"
export * from "./UsuarioLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports